import * as React from 'react'

import {
  Avatar,
  type AvatarBadgeProps,
  type EnhancedDimension,
} from '@factorialco/deprecated-design-system'

import buildUrl from 'modules/core/lib/buildUrl'

interface Props {
  size?: EnhancedDimension
  user?: IAvatar | ComputedAvatar
  badge?: AvatarBadgeProps
}

interface IAvatar {
  avatar: string
  fullName: string | (() => string)
}

interface ComputedAvatar {
  avatar?: string | null
  fullName: string | (() => string)
}

const UserAvatar = (props: Props) => {
  const { user, size, badge } = props
  const avatar = user && user.avatar
  const userName = user
    ? typeof user.fullName === 'function'
      ? user.fullName()
      : user.fullName
    : ''

  return <Avatar size={size} url={buildUrl(avatar)} label={userName} badge={badge} />
}

export default UserAvatar
